export default __webpack_public_path__ + "static/char-s-31-ko-cf445745dc08e0443e2bed8efa77c126.png";